import clientId from "../util/chatMessageId";

function conversations(state, uid) {
  return [...state.chatList, state.service, ...(state.globalChatList || [])].filter(user => user.uid == uid);
}

function finish(state, job, response) {
  clearTimeout(job.timer);
  const index = state.historyRequests.indexOf(job);
  if (index !== -1) state.historyRequests.splice(index, 1);
  conversations(state, job.address).forEach(user => {
    user.historyLoading = false;
    user.historyError = !response;
    if (response && !job.after_id) {
      user.historyLoaded = true;
      user.hasMoreHistory = !!response.has_more;
    }
  });
  job.resolve(response ? { lastId: Math.max(0, ...(response.data || []).map(message => Number(message.id))),
    hasMore: !!response.has_more } : false);
}

export default {
  state: () => ({ historyRequests: [], historySyncs: [] }),
  mutations: {
    checkpointChatHistory(state) {
      [...state.chatList, state.service, ...(state.globalChatList || [])].forEach(user => {
        if (user.recoveryAfterId == null && (user.list || []).length) {
          user.recoveryAfterId = Math.max(...user.list.map(message => Number(message.id) || 0));
        }
      });
    },
    finishChatHistory(state, response) {
      const job = state.historyRequests.find(item => item.request_id === response.request_id && item.address == response.address);
      if (job) finish(state, job, response);
    },
    clearChatHistory(state) {
      state.historyRequests.slice().forEach(job => finish(state, job, null));
      state.historySyncs = [];
      [...state.chatList, state.service, ...(state.globalChatList || [])].forEach(user => { user.syncingHistory = false; });
    },
  },
  actions: {
    async loadChatHistory({ state, dispatch }, { address, initial = false, after_id, until_id }) {
      const conversation = conversations(state, address)[0];
      if (!conversation || state.historyRequests.some(job => job.address == address)) return false;
      if (!initial && !after_id && conversation.hasMoreHistory === false) return false;
      const request = { opt: 3, address, origin: true, request_id: clientId() };
      if (after_id) { request.after_id = after_id; request.until_id = until_id; }
      else if (!initial && conversation.list && conversation.list.length) request.before_id = conversation.list[0].id;
      let resolve;
      const pending = new Promise(done => { resolve = done; });
      const job = { ...request, resolve };
      state.historyRequests.push(job);
      // 通过响应式数组取回对象，保证回调和清理使用同一引用。
      const activeJob = state.historyRequests[state.historyRequests.length - 1];
      conversations(state, address).forEach(user => { user.historyLoading = true; user.historyError = false; });
      const sent = await dispatch("wssend", request);
      if (!state.historyRequests.includes(activeJob)) return pending;
      if (!sent) finish(state, activeJob, null);
      else activeJob.timer = setTimeout(() => finish(state, activeJob, null), 15000);
      return pending;
    },
    async syncChatHistory({ state, dispatch }, { address, after_id, until_id }) {
      const users = conversations(state, address);
      const conversation = users[0];
      if (!conversation) return false;
      const target = Math.max(Number(until_id), Number(conversation.recoveryUntilId) || 0);
      const existing = state.historySyncs.find(run => run.address == address);
      if (existing) {
        existing.until_id = Math.max(existing.until_id, target);
        users.forEach(user => { user.recoveryUntilId = existing.until_id; });
        return false;
      }
      let cursor = conversation.recoveryAfterId == null ? Number(after_id) : Number(conversation.recoveryAfterId);
      state.historySyncs.push({ address, until_id: target });
      const run = state.historySyncs[state.historySyncs.length - 1];
      users.forEach(user => {
        user.syncingHistory = true;
        user.recoveryAfterId = cursor;
        user.recoveryUntilId = target;
      });
      try {
        while (cursor < run.until_id) {
          const pageTarget = run.until_id;
          const page = await dispatch("loadChatHistory", { address, after_id: cursor, until_id: pageTarget });
          if (!state.historySyncs.includes(run) || !page || (page.hasMore && page.lastId <= cursor)) return false;
          cursor = page.hasMore ? page.lastId : pageTarget;
          conversations(state, address).forEach(user => {
            user.recoveryAfterId = cursor;
            user.recoveryUntilId = run.until_id;
          });
        }
        conversations(state, address).forEach(user => {
          user.recoveryAfterId = null;
          user.recoveryUntilId = null;
          user.historyError = false;
        });
        return true;
      } finally {
        const index = state.historySyncs.indexOf(run);
        if (index !== -1) {
          state.historySyncs.splice(index, 1);
          conversations(state, address).forEach(user => { user.syncingHistory = false; });
        }
      }
    },
  },
};
